import { EditInsights } from "features/index";
import { GenericButton } from "shared/ui-basics/buttons";
import { FlexAlignCenter, FlexBetweenAlignCenter, IconDispatcher } from "shared/ui-basics/index";
import { useModal } from "use-modal-hook";
import InsightType from "../../../ui-basics/ui-components/InsightType";
import { Badge, BadgeWrapper, RemoveButton } from "./PicklistCard_style";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export const InsightCard = ({ index, entity, unlink, length, disable, recordId ,stageId,onClose}) => {
	const { t } = useTranslation();
	const allInsights =  useSelector((state) => state.insights.all_insights);
	const currentEntity = entity || allInsights.find((insight) => insight.id === recordId);
	const [insightModal] = useModal(EditInsights, { insightId: currentEntity?.id,stageId:stageId });
	if (!currentEntity) return <Badge key={entity?.id} id={entity?.id} disabled={true}>
	<BadgeWrapper index={index} length={length}  >
		{t("NO_ACCESS")}
	</BadgeWrapper>
</Badge>

	const handleDelete = (e) => {
		e.stopPropagation();
		unlink(currentEntity?.id);
	};
	const handleClick = (e) => {
		if(onClose){
			onClose();
		}
		e.stopPropagation();
		e.preventDefault();

		if (insightModal)
			insightModal();
	}
	return (
		<Badge key={currentEntity?.id} id={currentEntity?.id} onClick={handleClick}>
			<BadgeWrapper index={index} length={length}>
				<FlexAlignCenter>
					{IconDispatcher("GEM", "border border-dark rounded-circle p-1 me-2")}
					<div className="ellipsis obj-name px-2"title={currentEntity?.name} >
						{currentEntity?.name.defaultPlaceholder("INSIGHT_NAME")}
					</div>
				</FlexAlignCenter>

				<FlexBetweenAlignCenter className="px-2" minWidth='170px'>
					<div><InsightType typeId={currentEntity?.typeId} /></div>
					{!disable && (
						<RemoveButton>
							<GenericButton variant="light-link" id={currentEntity?.id} icon="X" iconClassName="p-0"  size='xs' className="p-0" onClick={handleDelete} />
						</RemoveButton>
					)}
				</FlexBetweenAlignCenter>

			</BadgeWrapper>
		</Badge>
	);
};
